import { DOCUMENT_ACCEPT } from "../../constants";
import {
  Button,
  ButtonVariant,
} from "@lya-protect/lya-protect-form-library/dist/UI";
import PlusCircle from "@endya-conformite/ui-kit/src/assets/icons/plus-circle.svg?react";
import classNames from "classnames";
import { ChangeEventHandler, ReactElement, useRef } from "react";
import styles from "./FileInputButton.module.scss";

export type FileInputButtonProps = {
  onChange: ChangeEventHandler<HTMLInputElement>;
  children: string | ReactElement;
  accept?: string;
  variant?: ButtonVariant | "input";
  onClick?: () => Promise<boolean>;
  icon?: JSX.Element;
  disabled?: boolean;
  className?: string;
  multiple?: boolean;
};
export function FileInputButton({
  onChange,
  multiple,
  accept = DOCUMENT_ACCEPT,
  children,
  icon,
  variant,
  onClick = () => Promise.resolve(true),
  disabled = false,
  className,
}: FileInputButtonProps) {
  const refFile = useRef<HTMLInputElement>(null);
  return (
    <>
      <input
        type="file"
        multiple={multiple}
        ref={refFile}
        onChange={onChange}
        accept={accept}
        className={styles.fileinput}
        disabled={disabled}
      />
      <Button
        variant={variant === "input" ? "text" : variant}
        iconVariant="right"
        icon={variant === "input" ? <PlusCircle /> : icon}
        onClick={() => {
          onClick()
            .then((shouldContinue) => {
              if (!shouldContinue || !refFile.current) return;
              refFile.current.value = "";
              refFile.current.click();
            })
            .catch((e) => {
              console.error(e);
            });
        }}
        className={classNames(
          {
            [styles.fileInputButton]: variant === "input",
          },
          className
        )}
        disabled={disabled}
      >
        {children}
      </Button>
    </>
  );
}
